import enLang from './entries/en-US';
import viLang from './entries/vi_VN';

const AppLocale = {
  vi: viLang,
  en: enLang,
};

export default AppLocale;
